import {
    FETCH_USER_DETAILS,
    FETCH_USER_DETAILS_FAIL,
    FETCH_USER_DETAILS_SUCCESS
} from './actionTypes';

export const fetchUserDetails = userId => ({
    type: FETCH_USER_DETAILS,
    payload: userId
});

export const fetchUserDetailsSuccess = user => ({
    type: FETCH_USER_DETAILS_SUCCESS,
    payload: user
});

export const fetchUserDetailsFail = error => ({
    type: FETCH_USER_DETAILS_FAIL,
    payload: error
});
